"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

var _defineProperty2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/defineProperty"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _router = _interopRequireDefault(require("./router"));

var _store = _interopRequireDefault(require("./store"));

var _nprogress = _interopRequireDefault(require("nprogress"));

require("nprogress/nprogress.css");

var _auth = require("@/utils/auth");

var _getPageTitle = _interopRequireDefault(require("@/utils/get-page-title"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

_nprogress.default.configure({
  showSpinner: false
}); // NProgress Configuration


var whiteList = ['/login', '/auth-redirect']; // no redirect whitelist

_router.default.beforeEach(
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(to, from, next) {
    var hasToken, hasRoles, _ref2, roles, accessRoutes;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // start progress bar
            _nprogress.default.start(); // set page title


            document.title = (0, _getPageTitle.default)(to.meta.title); // determine whether the user has logged in

            hasToken = (0, _auth.getToken)();

            if (!hasToken) {
              _context.next = 34;
              break;
            }

            if (!(to.path === '/login')) {
              _context.next = 9;
              break;
            }

            // if is logged in, redirect to the home page
            next({
              path: '/'
            });

            _nprogress.default.done();

            _context.next = 32;
            break;

          case 9:
            // determine whether the user has obtained his permission roles through getInfo
            hasRoles = _store.default.getters.roles && _store.default.getters.roles.length > 0;

            if (!hasRoles) {
              _context.next = 14;
              break;
            }

            next();
            _context.next = 32;
            break;

          case 14:
            _context.prev = 14;
            _context.next = 17;
            return _store.default.dispatch('user/getInfo');

          case 17:
            _ref2 = _context.sent;
            roles = _ref2.roles;
            _context.next = 21;
            return _store.default.dispatch('permission/generateRoutes', roles);

          case 21:
            accessRoutes = _context.sent;

            // dynamically add accessible routes
            _router.default.addRoutes(accessRoutes); // hack method to ensure that addRoutes is complete
            // set the replace: true, so the navigation will not leave a history record


            next(_objectSpread({}, to, {
              replace: true
            }));
            _context.next = 32;
            break;

          case 26:
            _context.prev = 26;
            _context.t0 = _context["catch"](14);
            _context.next = 30;
            return _store.default.dispatch('user/resetToken');

          case 30:
            next("/login?redirect=".concat(to.path));

            _nprogress.default.done();

          case 32:
            _context.next = 35;
            break;

          case 34:
            /* has no token*/
            if (whiteList.indexOf(to.path) !== -1) {
              // in the free login whitelist, go directly
              next();
            } else {
              // other pages that do not have permission to access are redirected to the login page.
              next("/login?redirect=".concat(to.path));

              _nprogress.default.done();
            }

          case 35:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[14, 26]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());

_router.default.afterEach(function () {
  // finish progress bar
  _nprogress.default.done();
});